export const сurrencies = [
  {
    name: 'USD',
    id: 'usd',
    symbol: '$',
    coinDigits: 0,
  },
  {
    name: 'EUR',
    id: 'eur',
    symbol: '€',
    coinDigits: 0,
  },
]
